module.exports = __webpack_public_path__ + "static/grafika7-92aa1faadec861820e1c08fc6719da58.png";